module.exports = __webpack_public_path__ + "img/white-stacked.c2d16379.png";